/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonChangeOfobject,
    JsonChangeOfobjectFromJSON,
    JsonChangeOfobjectFromJSONTyped,
    JsonChangeOfobjectToJSON,
} from './JsonChangeOfobject';

/**
 * 
 * @export
 * @interface JsonContingent
 */
export interface JsonContingent {
    /**
     * 
     * @type {Array<string>}
     * @memberof JsonContingent
     */
    allowedActions?: Array<JsonContingentAllowedActionsEnum>;
    /**
     * 
     * @type {Array<JsonChangeOfobject>}
     * @memberof JsonContingent
     */
    changes?: Array<JsonChangeOfobject>;
    /**
     * 
     * @type {number}
     * @memberof JsonContingent
     */
    contingentId?: number;
    /**
     * 
     * @type {string}
     * @memberof JsonContingent
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof JsonContingent
     */
    createdBy?: number;
    /**
     * 
     * @type {string}
     * @memberof JsonContingent
     */
    dayDate?: string;
    /**
     * 
     * @type {number}
     * @memberof JsonContingent
     */
    eventId?: number;
    /**
     * 
     * @type {number}
     * @memberof JsonContingent
     */
    limit?: number;
    /**
     * 
     * @type {string}
     * @memberof JsonContingent
     */
    owner?: string;
    /**
     * 
     * @type {number}
     * @memberof JsonContingent
     */
    siwiId?: number;
    /**
     * 
     * @type {number}
     * @memberof JsonContingent
     */
    siwiUsed?: number;
    /**
     * 
     * @type {string}
     * @memberof JsonContingent
     */
    status?: JsonContingentStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof JsonContingent
     */
    updatedAt?: string;
    /**
     * 
     * @type {number}
     * @memberof JsonContingent
     */
    updatedBy?: number;
    /**
     * 
     * @type {string}
     * @memberof JsonContingent
     */
    zone?: string;
}

/**
* @export
* @enum {string}
*/
export enum JsonContingentAllowedActionsEnum {
    View = 'VIEW',
    Edit = 'EDIT'
}/**
* @export
* @enum {string}
*/
export enum JsonContingentStatusEnum {
    Deleted = 'DELETED',
    Active = 'ACTIVE'
}

export function JsonContingentFromJSON(json: any): JsonContingent {
    return JsonContingentFromJSONTyped(json, false);
}

export function JsonContingentFromJSONTyped(json: any, ignoreDiscriminator: boolean): JsonContingent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'allowedActions': !exists(json, 'allowedActions') ? undefined : json['allowedActions'],
        'changes': !exists(json, 'changes') ? undefined : ((json['changes'] as Array<any>).map(JsonChangeOfobjectFromJSON)),
        'contingentId': !exists(json, 'contingentId') ? undefined : json['contingentId'],
        'createdAt': !exists(json, 'createdAt') ? undefined : json['createdAt'],
        'createdBy': !exists(json, 'createdBy') ? undefined : json['createdBy'],
        'dayDate': !exists(json, 'dayDate') ? undefined : json['dayDate'],
        'eventId': !exists(json, 'eventId') ? undefined : json['eventId'],
        'limit': !exists(json, 'limit') ? undefined : json['limit'],
        'owner': !exists(json, 'owner') ? undefined : json['owner'],
        'siwiId': !exists(json, 'siwiId') ? undefined : json['siwiId'],
        'siwiUsed': !exists(json, 'siwiUsed') ? undefined : json['siwiUsed'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'updatedAt': !exists(json, 'updatedAt') ? undefined : json['updatedAt'],
        'updatedBy': !exists(json, 'updatedBy') ? undefined : json['updatedBy'],
        'zone': !exists(json, 'zone') ? undefined : json['zone'],
    };
}

export function JsonContingentToJSON(value?: JsonContingent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'allowedActions': value.allowedActions,
        'changes': value.changes === undefined ? undefined : ((value.changes as Array<any>).map(JsonChangeOfobjectToJSON)),
        'contingentId': value.contingentId,
        'createdAt': value.createdAt,
        'createdBy': value.createdBy,
        'dayDate': value.dayDate,
        'eventId': value.eventId,
        'limit': value.limit,
        'owner': value.owner,
        'siwiId': value.siwiId,
        'siwiUsed': value.siwiUsed,
        'status': value.status,
        'updatedAt': value.updatedAt,
        'updatedBy': value.updatedBy,
        'zone': value.zone,
    };
}

